<template>
  <button class="shrink-0 group">
    <div
      class="relative overflow-hidden transition-all ease-spatial duration-[350ms]"
      :class="[
        color == 'primary' && 'bg-primary-container text-on-primary-container',
        color == 'secondary' && 'bg-secondary-container text-on-secondary-container',
        color == 'tertiary' && 'bg-tertiary-container text-on-tertiary-container',
        size == 'default' && 'h-14 w-14 rounded-large',
        size == 'small' && 'h-10 w-10 rounded-medium',
        size == 'large' && 'h-24 w-24 rounded-extra-large',
        size == 'extended' && 'h-14 rounded-large',
        !noShadows && 'shadow-1 hover:shadow-2',
      ]"
      :style="[size == 'extended' ? { width: contentWidth ? contentWidth + 'px' : 'auto' } : {}]"
    >
      <BaseStateLayer :type="color" />
      <div ref="content" class="flex w-fit items-center justify-center h-full px-4">
        <BaseIcon
          v-if="icon"
          :size="size != 'large' ? '24' : '36'"
          :class="[size == 'extended' && 'mr-2']"
          >{{ icon }}</BaseIcon
        >
        <span v-if="size == 'extended'" class="text-label-large whitespace-nowrap">
          <slot />
        </span>
      </div>
    </div>
  </button>
</template>
<script setup lang="ts">
import { useElementBounding } from '@vueuse/core'
import { useTemplateRef } from 'vue'
import BaseIcon from '../../icon/BaseIcon.vue'
import BaseStateLayer from '../../state-layer/BaseStateLayer.vue'
import { type FABColor } from './fab-color'
import { type FABSize } from './fab-size'

interface Props {
  size?: FABSize
  color?: FABColor
  icon?: string
  noShadows?: boolean
}

const { color = 'primary', size = 'default' } = defineProps<Props>()

const content = useTemplateRef<HTMLAnchorElement>('content')
const contentWidth = useElementBounding(content).width
</script>
